import React from "react";
import SurveysHomeUI from "./components/SurveysHomeUI";
import SurveyLayout from "../../components/SurveyLayout/SurveyLayout";
import { useLocation, useParams } from "react-router-dom";

const Main = () => {
  const { id } = useParams();
  const {pathname} = useLocation()

  return (
    <SurveyLayout pathname={pathname} id={id}>
      <SurveysHomeUI />
    </SurveyLayout>
  );
};

export default Main;
